// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alumni_profile_college_name_other_detail_wrap .alumni_profile_status.profile-header-status {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 14px 28px;
}

.alumni_profile_college_name_other_detail_wrap .profile-header-status > li {
    flex: 0 1 auto;
    width: auto;
    min-width: 130px;
    max-width: 100%;
    margin: 0;
}

.alumni_profile_college_name_other_detail_wrap .profile-header-status > li p {
    margin: 2px 0 0;
    overflow-wrap: anywhere;
}

.alumni_profile_college_name_other_detail_wrap .profile-header-status .profile-header-action {
    display: flex;
    flex: none;
    width: auto;
    margin-top: 6px;
}

.alumni_profile_college_name_other_detail_wrap .profile-header-status .profile-header-action .btn-send {
    width: auto;
    min-width: 123px;
    padding: 0 22px;
    flex-wrap: nowrap;
    justify-content: center;
    white-space: nowrap;
}

.alumni_profile_college_name_other_detail_wrap.has-company-slider .alumni_profile_college_name_other_detail .alumni_profile_other_detail {
    margin-left: 0;
    width: 100%;
}

@media (max-width: 575px) {
    .alumni_profile_college_name_other_detail_wrap .profile-header-status > li {
        min-width: calc(50% - 14px);
    }
}
`, "",{"version":3,"sources":["webpack://./src/features/alumni/alumni-profile/sections/ProfileHeader.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,UAAU;IACV,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ","sourcesContent":[".alumni_profile_college_name_other_detail_wrap .alumni_profile_status.profile-header-status {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    gap: 14px 28px;\n}\n\n.alumni_profile_college_name_other_detail_wrap .profile-header-status > li {\n    flex: 0 1 auto;\n    width: auto;\n    min-width: 130px;\n    max-width: 100%;\n    margin: 0;\n}\n\n.alumni_profile_college_name_other_detail_wrap .profile-header-status > li p {\n    margin: 2px 0 0;\n    overflow-wrap: anywhere;\n}\n\n.alumni_profile_college_name_other_detail_wrap .profile-header-status .profile-header-action {\n    display: flex;\n    flex: none;\n    width: auto;\n    margin-top: 6px;\n}\n\n.alumni_profile_college_name_other_detail_wrap .profile-header-status .profile-header-action .btn-send {\n    width: auto;\n    min-width: 123px;\n    padding: 0 22px;\n    flex-wrap: nowrap;\n    justify-content: center;\n    white-space: nowrap;\n}\n\n.alumni_profile_college_name_other_detail_wrap.has-company-slider .alumni_profile_college_name_other_detail .alumni_profile_other_detail {\n    margin-left: 0;\n    width: 100%;\n}\n\n@media (max-width: 575px) {\n    .alumni_profile_college_name_other_detail_wrap .profile-header-status > li {\n        min-width: calc(50% - 14px);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
